module.exports = __webpack_public_path__ + "img/frame (231).deb1ca85.jpg";